module.exports = __webpack_public_path__ + "static/img/342_phase_function_Paper_Points.2f654c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/342_phase_function_Paper_Points.png
// module id = S4UJ
// module chunks = 0